var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ white: _vm.withBackground },attrs:{"id":"item-footer"}},[_c('item-description',{ref:"description",attrs:{"id":"description"}}),_vm._v(" "),_c('cta-button',{ref:"cta"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }